import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import './i18n.js';
import './styles.css';
import { useAuth } from './auth/store.js';

// If the URL contains ?token=<accessToken> (injected by Studio preview links),
// bootstrap the player session from it before rendering.
async function bootstrapTokenFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get('token');
  if (!token) return;

  // Fetch the user profile with this token.
  const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:3001';
  try {
    const res = await fetch(`${API_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) return;
    const user = await res.json();
    useAuth.getState().setSession(user, token, '');
  } catch {
    // silently ignore — the login page will be shown instead
  } finally {
    // Remove ?token from the URL so it doesn't linger in history.
    params.delete('token');
    const newSearch = params.toString();
    const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : '') + window.location.hash;
    window.history.replaceState(null, '', newUrl);
  }
}

bootstrapTokenFromUrl().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
});
